interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <div className="flex items-center justify-center gap-2 mt-8">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="inline-flex items-center gap-1 px-3.5 h-9 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 whitespace-nowrap transition-colors cursor-pointer hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === current ? "page" : undefined}
          className={`w-9 h-9 rounded-md text-sm font-medium transition-colors cursor-pointer ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "bg-background-100 text-foreground-700 border border-background-200 hover:bg-background-200"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="inline-flex items-center gap-1 px-3.5 h-9 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 whitespace-nowrap transition-colors cursor-pointer hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}